export default __webpack_public_path__ + "static/cards-diagram-911b21054150720c1bf4f89ec44003c4.png";